module.exports = __webpack_public_path__ + "img/Isolated_Can_Icon.dd77399d.png";